import {
  authHeader,
  handleResponse,
  handleNoContentResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getSaGlobalRelease() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/sa/global`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function addSaGlobalRelease(formData) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(formData),
  };

  const endPoint = `/api/admin/v1/releases/analyzers/sa/global`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleNoContentResponse)
    .then((data) => {
      return data;
    });
}

function editSaGlobalRelease(formData) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(formData),
  };

  const endPoint = `/api/admin/v1/releases/analyzers/sa/global`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleNoContentResponse)
    .then((data) => {
      return data;
    });
}

export const saGlobalReleaseService = {
  getSaGlobalRelease,
  addSaGlobalRelease,
  editSaGlobalRelease,
};
